var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecuritySetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.507,
    height: 30.694,
    viewBox: "0 0 25.507 30.694",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4adede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6172d6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-security",
    "data-name": "Icon material-security",
    d: "M15.754-.141,28.507,5.527V14A17.535,17.535,0,0,1,25,24.416a15.96,15.96,0,0,1-8.892,6.05l-.356.087-.356-.087a15.96,15.96,0,0,1-8.892-6.05A17.535,17.535,0,0,1,3,14V5.527Zm9.754,7.618L15.754,3.141,6,7.476V14c0,6.185,4.168,11.9,9.754,13.455C21.339,25.9,25.507,20.189,25.507,14Z",
    transform: "translate(-3 0.141)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuritySetting);
export default __webpack_public_path__ + "static/media/SecuritySetting.77ec090dc5cdcbf8bcd3627690b9a487.svg";
export { ForwardRef as ReactComponent };